import { CONTACT } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";

const ContactInfo = () => {
  const { copy } = useLanguage();

  return (
    <div className="contact-info" data-testid="contact-info">
      <p className="section-kicker" data-testid="contact-kicker">
        {copy.contact.kicker}
      </p>
      <h2 className="section-title" data-testid="contact-title">
        {copy.contact.title}
      </h2>
      <div className="contact-details" data-testid="contact-details">
        <a
          href={CONTACT.whatsappLink}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-whatsapp"
        >
          {copy.contact.whatsappLabel}: {CONTACT.phoneDisplay}
        </a>
        <a href={`mailto:${CONTACT.emailSecondary}`} data-testid="contact-email-primary">
          {CONTACT.emailSecondary}
        </a>
        <a href={`mailto:${CONTACT.emailPrimary}`} data-testid="contact-email-secondary">
          {CONTACT.emailPrimary}
        </a>
        <a
          href={CONTACT.linkedin}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-linkedin"
        >
          LinkedIn: nexus-benin-sas
        </a>
        <p data-testid="contact-company">
          {copy.contact.companyLabel}: {CONTACT.company}
        </p>
        <p data-testid="contact-ifu">
          {copy.contact.ifuLabel}: {CONTACT.ifu}
        </p>
        <p data-testid="contact-rccm">
          {copy.contact.rccmLabel}: {CONTACT.rccm}
        </p>
        <div className="contact-address" data-testid="contact-address">
          <p className="contact-address-title" data-testid="contact-address-title">
            {copy.contact.addressTitle}
          </p>
          <p data-testid="contact-address-trade">
            {copy.contact.addressTradeLabel}: {CONTACT.tradeName}
          </p>
          <p data-testid="contact-address-country">
            {copy.contact.addressCountryLabel}: {CONTACT.country}
          </p>
          <p data-testid="contact-address-department">
            {copy.contact.addressDepartmentLabel}: {CONTACT.department}
          </p>
          <p data-testid="contact-address-commune">
            {copy.contact.addressCommuneLabel}: {CONTACT.commune}
          </p>
          <p data-testid="contact-address-arrondissement">
            {copy.contact.addressArrondissementLabel}: {CONTACT.arrondissement}
          </p>
          <p data-testid="contact-address-quartier">
            {copy.contact.addressQuartierLabel}: {CONTACT.quartier}
          </p>
        </div>
      </div>
      <a
        className="secondary-button light"
        href={CONTACT.whatsappLink}
        target="_blank"
        rel="noreferrer"
        data-testid="contact-whatsapp-button"
      >
        {copy.contact.button}
      </a>
    </div>
  );
};

export default ContactInfo;